export default {
  MERGE_USER_DUPLICATES_START: 'MergeUserDuplicatesStart',
  MERGE_USER_DUPLICATES_END: 'MergeUserDuplicatesEnd',
  TOGGLE_USER_MERGE_CONFIRM_DIALOG: 'ToggleUserMergeConfirmDialog'
};